import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { formatDateDDMMYYYY } from "../../../../helpers/functions/dateFormatter";

const SignatureVerificationDocumentPDF = ({ formData }) => {
  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      fontSize: 11,
      paddingTop: 60,
      paddingBottom: 60,
      paddingLeft: 70,
      paddingRight: 70,
      fontFamily: "Times-Roman",
      lineHeight: 1.5,
    },
    heading: {
      fontSize: 16,
      fontWeight: "bold",
      fontFamily: "Times-Bold",
      textAlign: "center",
      textDecoration: "underline",
      marginBottom: 15,
    },
    subHeading: {
      fontSize: 14,
      fontWeight: "bold",
      fontFamily: "Times-Bold",
      textAlign: "center",
      marginBottom: 35,
    },
    paragraph: {
      fontSize: 11,
      lineHeight: 1.5,
      textAlign: "justify",
      marginBottom: 20,
    },
    bold: {
      fontWeight: "bold",
      fontFamily: "Times-Bold",
    },
    signatureSection: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 100,
      marginBottom: 60,
    },
    signatureColumn: {
      width: "45%",
    },
    signatureLabel: {
      fontSize: 11,
      textAlign: "left",
      marginBottom: 10,
    },
    signatureName: {
      fontSize: 11,
      textAlign: "left",
    },
    rightColumnText: {
      fontSize: 11,
      marginBottom: 15,
      textAlign: "right",
    },
    dateSection: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 15,
      fontSize: 11,
    },
  });

  const currentDate = new Date();
  const formattedDate = formatDateDDMMYYYY(currentDate);
  const isIndividual = formData?.businessType === "individual";
  const isProprietor = ["proprietor", "pvt_ltd", "partnership"].includes(
    formData?.businessType
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <Text style={styles.heading}>Signature Verification Letter</Text>

        {/* TO WHOMSOEVER IT MAY CONCERN */}
        <Text style={styles.subHeading}>TO WHOMSOEVER IT MAY CONCERN</Text>

        {/* First Paragraph */}
        <Text style={styles.paragraph}>
          This is to certify that{" "}
          <Text style={styles.bold}>
            {isIndividual
              ? `${
                  formData?.sv_account_holder_name || formData?.personName || ""
                }`
              : `${
                  formData?.sv_organization_name || formData?.companyName || ""
                }`}
          </Text>
          {isIndividual
            ? " , residing at "
            : " , with the office at "}
          <Text style={styles.bold}>
            {isIndividual
              ? `${
                  formData?.sv_account_holder_address || formData?.address || ""
                }`
              : `${
                  formData?.sv_organization_address || formData?.address || ""
                }`}
          </Text>
          {isIndividual
            ? " , is maintaining a bank account "
            : " , is maintaining a bank account "}
          <Text style={styles.bold}>
            {formData?.sv_account_number || formData?.account_no || ""}
          </Text>
          {" with our Bank "}
          <Text style={styles.bold}>
            {formData?.sv_bank_name || formData?.bank_name || ""}
          </Text>
          {
            " , and is operating that account in the normal course of its business/activities."
          }
        </Text>

        {/* Second Paragraph */}
        <Text style={styles.paragraph}>
          Mr./Ms./Mrs.{" "}
          <Text style={styles.bold}>
            {formData?.sv_authorized_signatory !== undefined && formData?.sv_authorized_signatory !== '' ? formData?.sv_authorized_signatory : (formData?.personName || "")}
          </Text>
          {
            " is the authorized signatory for the operation of the account. His/Her signature, as appearing below, is duly attested (as per the records available with the bank)."
          }
        </Text>

        {/* Signature Section */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureColumn}>
            <Text style={styles.signatureLabel}>
              (Signature of the Authorized Signatory)
            </Text>
            <Text style={styles.signatureName}>
              Name: {isIndividual ? "Mr. " : ""}
              <Text style={styles.bold}>
                {formData?.sv_name !== undefined && formData?.sv_name !== '' ? formData?.sv_name : (formData?.personName || formData?.sv_authorized_signatory || "")}
              </Text>
            </Text>
          </View>
          <View style={styles.signatureColumn}>
            <Text style={[styles.rightColumnText]}>
              (Signature of the Branch Manager) {"   "}
            </Text>
            <Text style={styles.rightColumnText}>
              Name: _______________________
            </Text>
            <Text style={styles.rightColumnText}>
              Designation: __________________
            </Text>
            <Text style={styles.rightColumnText}>
              Phone No.: ___________________
            </Text>
          </View>
        </View>

        {/* Date and Bank Seal */}
        <View style={styles.dateSection}>
          <Text>Date: ____________</Text>
          <Text>(Bank Seal)</Text>
        </View>
      </Page>
    </Document>
  );
};

export default SignatureVerificationDocumentPDF;
